/* eslint-disable array-callback-return */
import { directive as onClickaway } from 'vue-clickaway';

export default {

  directives: {
    onClickaway,
  },

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `popover-${this._uid}`;
      },
    },
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      default: '',
    },
    helper: {
      type: String,
      default: '',
    },
    component: {
      type: String,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    show() {
      $(`#${this.id}`).popover('show');
    },

    close() {
      $(`#${this.id}`).popover('hide');
    },
  },
};
